const TRIAL_PLAN_NAME = 'trial-pro-monthly'

const StorageKeys = {
  enjoyTrialPopup: 'enjoy_trial_popup',
  trialNotAvailablePopup: 'trial_not_available_popup',
}

export function isTrialLink(url) {
  if (!url) return false

  return url.includes('code=AHA_21169')
}

export function scheduleShowEnjoyTrialPopup(user) {
  sessionStorage.setItem(`${StorageKeys.enjoyTrialPopup}_${user.id}`, 'true')
}

export function canShowEnjoyTrialPopup(user) {
  return sessionStorage.getItem(`${StorageKeys.enjoyTrialPopup}_${user.id}`) === 'true'
}

export function scheduleShowTrialNotAvailablePopup(user) {
  sessionStorage.setItem(`${StorageKeys.trialNotAvailablePopup}_${user.id}`, 'true')
}

export function canShowTrialNotAvailablePopup(user) {
  return sessionStorage.getItem(`${StorageKeys.trialNotAvailablePopup}_${user.id}`) === 'true'
}

export function clearPopupSessionData(user) {
  sessionStorage.removeItem(`${StorageKeys.enjoyTrialPopup}_${user.id}`)
  sessionStorage.removeItem(`${StorageKeys.trialNotAvailablePopup}_${user.id}`)
}

export function isPlanDifferentFromTrial(user) {
  return user && user.plan !== TRIAL_PLAN_NAME
}
